// extracted by mini-css-extract-plugin
export default {"bg":"ObjEdit_bg__qpUjM","up-arrow":"ObjEdit_up-arrow__5Kxq9","down-arrow":"ObjEdit_down-arrow__NDEVE"};